import { render, staticRenderFns } from "./login-confirm.vue?vue&type=template&id=5e1c0f80&scoped=true"
import script from "./login-confirm.vue?vue&type=script&lang=js"
export * from "./login-confirm.vue?vue&type=script&lang=js"
import style0 from "./login-confirm.vue?vue&type=style&index=0&id=5e1c0f80&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e1c0f80",
  null
  
)

export default component.exports